export default __webpack_public_path__ + "static/media/funfacts_icon.40be718f.svg";